<template>
  <div id="zzsx">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'zzsx'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/portal/guide/zzsx/Zzsx.vue